// extracted by mini-css-extract-plugin
export default {"header":"OOPByClasses_header__k1UkM","placeHolderShimmer":"OOPByClasses_placeHolderShimmer__SiiMK"};